import React from "react";
import Table from "@mui/joy/Table";
import { useEffect, useState } from "react";


interface TableProps {
  data: any[];
  columns: {
    id: number;
    label: string;
    property: string;
  }[];
}

const LevelTable = ({ data, columns }: TableProps) => {
  const [formattedData, setFormattedData] = useState<any[]>([]);

/**
 * Formats the data array by mapping over each milestone and formatting the date property using the formatDate function.
 * @param data - The array of milestones to format.
 * @param columns - The array of columns to use for formatting.
 * @returns An array of formatted milestones.
 */
  useEffect(() => {
    if (data.length !== 0) {
      //create dictionary with key as rowid and value as row
      let rows: any = {};
      //loop over each data item
      data.forEach((item) => {
        //create a new row if it doesn't exist
        if (!rows[item?.rowId]) {
          rows[item.rowId] = {};
        }
        //add the column value to the row
        rows[item?.rowId][item?.level] = item?.name;
      });

      setFormattedData(Object.values(rows));
    }

  }, []);


  return (
    <div className="table">
    <Table hoverRow>
      <thead>
        <tr>
          {columns?.map((column) => (
            <th key={column?.id}>{column?.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
      {formattedData?.map((data) => (
          <tr key={data?.id}>
            {columns?.map((column) => (
              <td key={column?.id}>{getValueByLevel(data, column)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>
    </div>
  );
};

export default LevelTable;

function getValueByLevel(data: any, column: any) {
if (data.length !== 0){
 let value = data[column?.id];
  return value;
}
}
